import script from "./SponsorTab.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorTab.vue?vue&type=script&setup=true&lang=js"

import "./SponsorTab.vue?vue&type=style&index=0&id=5aa4d995&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aa4d995"]])

export default __exports__